import { HttpErrorResponse } from '@angular/common/http';

import { PrismicData } from '@app-model/api';

import * as PrismicActions from '../../store/prismic/prismic.actions';

export const featureKey = 'prismicState';

export interface State {
  data: PrismicData;
  error: HttpErrorResponse;
  loading: boolean;
}

const InitialState: State = {
  data: undefined,
  error: undefined,
  loading: false,
};

export function reducer(state = InitialState, action: PrismicActions.All): State {
  switch (action.type) {
    case PrismicActions.LOAD_PRISMIC_DATA: {
      return { ...state, loading: true, error: undefined };
    }

    case PrismicActions.LOAD_PRISMIC_DATA_SUCCESS: {
      return { ...state, data: action.payload.data, loading: false, error: undefined };
    }

    case PrismicActions.LOAD_PRISMIC_DATA_FAILURE: {
      return { ...state, error: undefined, loading: false };
    }

    default: {
      return state;
    }
  }
}
